<template>
  <div class="app">
    <div class="DisplayBox">
      <div class="Display">
        <p>{{tateData.integral}}</p>
        <span>当前积分</span>
      </div>
      <div class="Dxian"></div>
      <div class="Display">
        <p>{{tateData.usintegral}}</p>
        <span>可用积分</span>
      </div>
    </div>

    <div class="Exchange">
      <div class="ExctopBOX">
        <div class="ExcLnt">
          <p>兑换积分</p>
          <input type="number" v-model="integral" @input="inputMony" @focus="focus" @blur="blur" />
        </div>
        <div class="ExcAmo">
          <p>
            兑换金额:
            <span style="color:#46a1ff">{{mony}}</span>元
          </p>
          <div @click="clickMoney(tateData.usintegral)">兑换</div>
        </div>
      </div>
      <div class="ExcbotBox">
        <span>积分兑换比例:{{tateData.bl}}</span>
      </div>
    </div>
    <div class="ExcRec">
      <span class="Rec">兑换记录</span>
      <i class="iconfont iconxia" @click="clickZankai"></i>
      <span class="Recqb">
        <span @click="clickZankai">{{catName}}</span>
        <div :class="[zankai == true?'tanchu zankai':'tanchu']">
          <div
            v-for="(item,index) in categoryData"
            :key="index"
            @click="clickCat(item.num,item.name)"
          >{{item.name}}</div>
        </div>
      </span>
    </div>
    <div class="BonusPoiBox" ref="Bonus" @scroll="scrollEvent">
      <div class="Exclist" v-for="(item,index) in ExcData" :key="index">
        <div class="ExclistReward">
          <span>{{item.DSC}}</span>
          <span class="ExclistReward_right">{{item.QTY}}</span>
        </div>
        <div class="ExcDat">{{item.DAT}}</div>
      </div>
    </div>
    <!-- 背景 -->
    <div class="borBox" v-if="binding"></div>
    <div class="Choice" v-if="binding">
      <div class="cho1">确认是否兑换</div>
      <div class="cho2">
        <div style="border-right:1px solid #e0e0e0;" @click="clickBinding(false)">取消</div>
        <div @click="clickBinding(true)">确定</div>
      </div>
    </div>
    <Return></Return>
    <Promptbox v-if="prom" :message="Tips"></Promptbox>
    <loading v-if="load"></loading>
  </div>
</template>
<script>
export default {
  name: "exchange",
  data() {
    return {
      categoryData: [
        { name: "全部", num: "0" },
        { name: "获取", num: "1" },
        { name: "兑换", num: "2" }
      ],
      load: false,
      appcode: "",
      vipno: "",
      tateData: [],
      ExcData: [],
      page: 1,
      zankai: false,
      scrollFalse: true,
      type: 0,
      integral: 0,
      Tips: "",
      prom: false,
      binding: false,
      mony:0,
      catName:'全部'
    };
  },
  mounted() {
    this.Query()
  },
  methods: {
    Query(){
       this.load = true;
        this.appcode = localStorage.getItem("appcode");
        this.vipno = localStorage.getItem("VIPNO");
        this.R(
          "Queryintegral_new",
          { appcode: this.appcode, vipno: this.vipno },
          r => {
            this.tateData = r.data.table1[0];
            this.changeExchange(this.type);
            console.log(r);
          },
          err => {
            console.log(err);
          }
        );
    },
    scrollEvent() {
      if (this.scrollFalse) {
        if (
          this.$refs.Bonus.offsetHeight +
            this.$refs.Bonus.scrollTop -
            this.$refs.Bonus.scrollHeight ==
          0
        ) {
          this.page += 1;
          this.changeExchange(this.type);
        }
      }
    },
    changeExchange(type) {
      this.load = true;
      this.R(
        "queryJFJL",
        {
          appcode: this.appcode,
          vipno: this.vipno,
          type,
          num: 10,
          page: this.page
        },
        r => {
          if (r.data.table1 != undefined) {
            this.ExcData = r.data.table1;
          } else {
            this.scrollFalse = false;
          }
          this.load = false;
        },
        err => {
          console.log(err);
        }
      );
    },
    clickZankai() {
      this.zankai = !this.zankai;
    },
    clickCat(val,name) {
      this.page = 1;
      this.ExcData = [];
      this.type = val;
      console.log(val)
      this.catName = name
      this.changeExchange(this.type);
    },
    inputMony(val){
      this.integral = val.target.value*1
      this.mony = parseInt(this.integral/this.tateData.minintegral)*this.tateData.minmoney
      this.mony = this.mony.toFixed(1)
      console.log(this.mony)
    },
    clickMoney(val) {
      if (this.integral * 1 > 0) {
        if (this.integral * 1 > this.tateData.usintegral * 1) {
          this.ChangeTishi(8);
        } else if ((this.integral * 1)<(this.tateData.minintegral * 1)) {
          this.ChangeTishi(9);
        }else if((this.integral * 1)%(this.tateData.minintegral*1)!=0){
          this.ChangeTishi(10);
        }else if((this.integral * 1)%(this.tateData.minintegral*1)==0){
          this.binding = true
        }
      } else {
        this.ChangeTishi(7);
      }
    },
    ChangeTishi(val) {
      this.Tips = val;
      this.prom = true;
      let timer = setTimeout(() => {
        this.prom = false;
        clearTimeout(timer);
      }, 1000);
    },
    clickBinding(val) {
      if (val) {
        this.load = true;
          this.appcode = localStorage.getItem("appcode");
          this.vipno = localStorage.getItem("VIPNO");
          this.R(
            "IntegralforWater_new",
            { appcode: this.appcode, vipno: this.vipno,qty:this.integral,money:this.mony},
            r => {
              console.log(r)
              this.Query();
            },
            err => {
              console.log(err);
            }
          );
        this.binding = false;
      } else {
        this.binding = val;
      }
    },
    focus(){
        this.focusFalse = true
        clearTimeout(this.timer)
    },
    blur(){
        this.focusFalse = false
        this.timer = setTimeout(() => {
        window.scrollTo(0,0)
        // 间隔设为10，减少页面失去焦点定时器的突兀感，
        },10)
    }
  },
  destroyed() {
   this.timer = setTimeout(() => {
        window.scrollTo(0,0)
        // 间隔设为10，减少页面失去焦点定时器的突兀感，
        clearTimeout(this.timer)
        },10)
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
}
.DisplayBox {
  height: 55px;
  background: #fff;
  width: 90%;
  margin-left: 5%;
  margin-top: 8px;
  border-radius: 5px;
  box-shadow: 0px 0px 4px 0px #bdbdbd;
}
.Display {
  float: left;
  width: 49%;
  height: 65px;
  text-align: center;
  font-size: 10px;
  color: #212121;
}
.Display > p {
  margin-top: 12px;
  margin-bottom: 6px;
  font-weight: bold;
}
.Display > span {
  font-size: 8px;
  margin-top: 10px;
}
.Dxian {
  height: 25px;
  margin-top: 15px;
  border-right: 0.5px solid #e0e0e0;
  float: left;
}
.Exchange {
  height: 70px;
  background: #fff;
  margin-top: 10px;
  border-bottom: 0.5px solid #e0e0e0;
}
.ExctopBOX {
  height: 50px;
  border-bottom: 0.5px solid #e0e0e0;
}
.ExcLnt {
  width: 30%;
  height: 50px;
  float: left;
  margin-left: 5%;
  font-size: 8px;
}
.ExcLnt > p {
  margin-top: 8px;
  margin-bottom: 4px;
}
.ExcLnt > input {
  font-size: 16px;
  font-weight: bold;
  color: #212121;
  width: 100%;
  outline: none;
  border: 0px;
}
.ExcAmo {
  width: 60%;
  height: 50px;
  float: right;
  margin-right: 5%;
  text-align: right;
  font-size: 8px;
}
.ExcAmo > p {
  margin-top: 8px;
  margin-bottom: 6px;
}
.ExcAmo > div {
  text-align: center;
  width: 35%;
  height: 18px;
  background: #46a1ff;
  float: right;
  border-radius: 9px;
  line-height: 18px;
  color: #fff;
  font-size: 8px;
}
.ExcbotBox > span {
  margin-left: 5%;
  color: #9e9e9e;
  line-height: 20px;
  font-size: 7px;
}
.BonusPoiBox {
  height: calc(100% - 189px);
  width: 100%;
  background: #fff;
  overflow: scroll;
}
.ExcRec {
  border-bottom: 0.5px solid #e0e0e0;
  height: 34px;
  position: relative;
  top: 0;
  background: #fff;
  margin-top: 10px;
}
.Rec {
  float: left;
  color: #212121;
  margin-left: 5%;
  line-height: 36px;
  font-size: 9px;
}
.Recqb {
  float: right;
  margin-right: 2%;
  line-height: 36px;
  font-size: 9px;
  color: #757575;
  position: relative;
}
.iconfont {
  float: right;
  margin-right: 5%;
  line-height: 36px;
  font-size: 18px;
  color: #757575;
}
.Exclist {
  border-bottom: 0.5px solid #e0e0e0;
  height: 42px;
}
.Exclist > div {
  width: 95%;
  float: right;
}
.ExclistReward {
  height: 16px;
  margin-top: 8px;
  font-size: 9px;
  color: #212121;
}
.ExclistReward_right {
  float: right;
  margin-right: 5%;
  color: #46a1ff;
}
.ExcDat {
  color: #757575;
  font-size: 8px;
}
.tanchu {
  width: 50px;
  height: 0px;
  background: #fff;
  position: absolute;
  left: -6px;
  top: 30px;
  box-shadow: 0px 0px 3px 0px #bdbdbd;
  border-radius: 3px;
  transition: all 0.5s;
  overflow: hidden;
}
.zankai {
  height: 69px;
}
.tanchu > div {
  height: 23px;
  text-align: center;
  line-height: 23px;
  font-size: 8px;
}
.borBox {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 99;
}
.Choice {
  width: 120px;
  height: 60px;
  background: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -30px;
  margin-left: -60px;
  z-index: 999;
  box-shadow: 0px 0px 5px 0px #757575;
  border-radius: 4px;
}
.cho1 {
  height: 35px;
  line-height: 35px;
  font-size: 11px;
  color: #212121;
  text-align: center;
}
.cho2 {
  height: 25px;
}
.cho2 > div {
  width: calc(50% - 0.5px);
  border-top: 0.5px solid #e0e0e0;
  float: left;
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/exchange/index.vue